import appNotificationsService from '@/services/appNotificationsService.js'

const state = {
  appNotifications: [],
  lastAppNotifications: [],
  loadingAppNotifications: false,
  newNotifications: 0,
  totalAppNotifications: 0,
  paginationAppNotifications: {}
}

const mutations = {
  'SET_LAST_NOTIFICATIONS' (state, lastAppNotifications) {
    state.lastAppNotifications = lastAppNotifications.slice(0, 10)
  },
  'SET_APP_NOTIFICATIONS' (state, appNotifications) {
    state.appNotifications = appNotifications
  },
  'SET_LOADING_APP_NOTIFICATIONS' (state, status) {
    state.loadingAppNotifications = status
  },
  'SET_NEW_NOTIFICATIONS' (state, newNotifications) {
    state.newNotifications = newNotifications
  },
  'SET_PAGINATION_APP_NOTIFICATIONS' (state, pagination) {
    state.paginationAppNotifications = pagination
  },
  'SET_TOTAL_APP_NOTIFICATIONS' (state, totalAppNotifications) {
    state.totalAppNotifications = totalAppNotifications
  }
}

const actions = {
  async getLastAppNotifications (vuexContext) {
    const token = vuexContext.getters.token
    const response = await appNotificationsService.getLastAppNotifications(token)
    vuexContext.commit('SET_NEW_NOTIFICATIONS', 0)
    vuexContext.commit('SET_LAST_NOTIFICATIONS', response.notifications.rows)
    return true
  },
  async getAppNotifications (vuexContext) {
    try {
      await vuexContext.commit('SET_LOADING_APP_NOTIFICATIONS', true)
      const token = vuexContext.getters.token
      const response = await appNotificationsService.getAppNotifications(
        token,
        vuexContext.state.paginationAppNotifications
      )

      vuexContext.commit('SET_TOTAL_APP_NOTIFICATIONS', response.notifications.count)
      vuexContext.commit('SET_APP_NOTIFICATIONS', response.notifications.rows)
      vuexContext.commit('SET_LOADING_APP_NOTIFICATIONS', false)
      return true
    } catch (error) {
      vuexContext.commit('SET_LOADING_APP_NOTIFICATIONS', false)
      throw error
    }
  },
  markAppNotificationAsViewed (vuexContext, notificationId) {
    const token = vuexContext.getters.token
    return appNotificationsService.markAppNotificationAsViewed(token, notificationId)
  }
}

const getters = {}

export default { state, mutations, actions, getters }
